
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/navbar.js';
            vueApps['app/navbar.js'] = App1;
        

            import App2 from './app/dummy.js';
            vueApps['app/dummy.js'] = App2;
        

            import App3 from './app/search.js';
            vueApps['app/search.js'] = App3;
        

            import App4 from './app/Wieck.js';
            vueApps['app/Wieck.js'] = App4;
        

            import App5 from './Kurzurlaub.js';
            vueApps['Kurzurlaub.js'] = App5;
        

            import App6 from './LastMinuteAngebote.js';
            vueApps['LastMinuteAngebote.js'] = App6;
        

            import App7 from './SimilarUnits.js';
            vueApps['SimilarUnits.js'] = App7;
        

            import App8 from './IndexUnits.js';
            vueApps['IndexUnits.js'] = App8;
        

            import App9 from './IndexUnits2.js';
            vueApps['IndexUnits2.js'] = App9;
        

            import App10 from './app/Born.js';
            vueApps['app/Born.js'] = App10;
        

            import App11 from './app/Urlaub-mit-Hund.js';
            vueApps['app/Urlaub-mit-Hund.js'] = App11;
        

            import App12 from './app/Zingst.js';
            vueApps['app/Zingst.js'] = App12;
        

            import App13 from './app/Prerow.js';
            vueApps['app/Prerow.js'] = App13;
        

        
                import Comp14 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp14);
            

                import Comp15 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp15);
            

                import Comp16 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp16);
            

                import Comp17 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp17);
            

                import Comp18 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp18);
            

                import Comp19 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp19);
            

                import Comp20 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp20);
            

                import Comp21 from './carousel.vue';
                Vue.component('owl-carousel',Comp21);
            

                import Comp22 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp22);
            

                import Comp23 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp23);
            

                import Comp24 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp24);
            

                import Comp25 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp25);
            

                import Comp26 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp26);
            

                import Comp27 from './ImageCarousel.vue';
                Vue.component('img-carousel',Comp27);
            

                import Comp28 from './stardisplay.vue';
                Vue.component('star-display',Comp28);
            

                import Comp29 from './comp/Paginate.vue';
                Vue.component('voffice-paginate',Comp29);
            

                import Comp30 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp30);
            

                import Comp31 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp31);
            

                import Comp32 from './pricehelp.vue';
                Vue.component('price-help',Comp32);
            

                import Comp33 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp33);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    